<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header class="headline">{{ $t('filters') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col class="col-12 col-sm-6 col-md-3 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.parent_category_id" :label="parentCategories.label"
                            :items="parentCategories.valuesData" item-text="name" item-value="id" @change="filterChange"
                            :disabled="showDeletedCategories" hide-no-data clearable multiple color="teal lighten-2"
                            item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-6 col-md-3 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.category_id" :label="categories.label"
                            :items="categories.valuesData" item-text="name" item-value="id" @change="filterChange"
                            :disabled="showDeletedCategories" hide-no-data clearable multiple color="teal lighten-2"
                            item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-6 col-md-3 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.category_status" :label="categoryStatuses.label"
                            :items="categoryStatuses.valuesData" item-text="name" item-value="value"
                            @change="filterChange" :disabled="showDeletedCategories" hide-no-data clearable multiple color="teal lighten-2"
                            item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-6 col-md-3 d-flex justify-center">
                        <v-autocomplete v-model="activeFilters.category_code" :label="categoryCodes.label"
                            :items="categoryCodes.valuesData" item-text="name" item-value="value" @change="filterChange"
                            :disabled="showDeletedCategories" hide-no-data clearable multiple color="teal lighten-2"
                            item-color="teal lighten-2"></v-autocomplete>
                    </v-col>
                    <v-col class="col-12 col-sm-6 d-flex justify-center">
                        <v-switch v-model="activeFilters.category_without_products"
                            :label="categoryWithoutProducts.label" @change="filterChange"
                            :disabled="showDeletedCategories" color="teal lighten-2"></v-switch>
                    </v-col>
                    <v-col class="col-12 col-sm-6 d-flex justify-center">
                        <v-switch v-model="activeFilters.category_deleted" :label="categoryDeleted.label"
                            @change="onDeletedFilterChange" color="teal lighten-2"></v-switch>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { MixinFiltersGeneral } from '../../mixins'
import { FilterService } from "../../services";

export default {
    name: "CategoriesFilters",
    mixins: [MixinFiltersGeneral],
    data() {
        return {
            panel: null,
            activeFilters: {},
            layout: [],
        }
    },
    computed: {
        categories() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryID.systemName);
            return filter || {};
        },
        parentCategories() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.parentCategoryID.systemName);
            return filter || {};
        },
        categoryStatuses() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryStatus.systemName);
            return filter || {};
        },
        categoryCodes() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryCode.systemName);
            return filter || {};
        },
        categoryWithoutProducts() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryWithoutProducts.systemName);
            return filter || {};
        },
        categoryDeleted() {
            const filter = this.layout.find(item => item.systemName === this.filtersGeneral.categoryDeleted.systemName);
            return filter || {};
        },
        showDeletedCategories() {
            return Boolean(this.activeFilters.category_deleted);
        },
        needRefresh() {
            return this.$store.state.updateCategoriesFilters;
        }
    },
    methods: {
        getLayout() {
            this.setFiltersFromUrl();
            FilterService.setAuth(this.$store.getters.token);
            return FilterService.getCategoriesLayout()
                .then(res => {
                    this.layout = [...res.data];
                })
                .catch(err => { console.log(err) });
        },
        filterChange() {
            this.addFiltersToUrl(this.activeFilters, this.$route);
            this.$emit('filter-change', { ...this.activeFilters });
        },
        onDeletedFilterChange(value) {
            this.activeFilters = value ? { category_deleted: true } : {};

            this.filterChange();
        },
        setFiltersFromUrl() {
            this.activeFilters = this.getFiltersFromUrl();
            this.filterChange();
        }
    },
    created() {
        this.getLayout();
    },
    watch: {
        needRefresh(value) {
            if (value) {
                this.getLayout();
                this.$nextTick(() => {
                    this.$store.commit('setUpdateCategoriesFilters', false);
                });
            }
        }
    }

}
</script>
